import { useState } from "react";
import { Button, Carousel } from "react-bootstrap";
import NotificationModal from "../modal/modal";

function Hero() {
  const [modalNotify, setModalNotify] = useState(false);

  const heroImages = [
    "/slides/slide1.avif",
    "/slides/slide2.avif",
    "/slides/slide3.avif",
    "/slides/slide4.avif",
    "/slides/slide5.avif",
    "/slides/slide6.avif",
    "/slides/slide7.avif",
  ];

  return (
    <div id="home" className="hero-slider">
      <NotificationModal
        show={modalNotify}
        onHide={() => setModalNotify(false)}
      />

      <Carousel
        fade
        controls={false}
        indicators={false}
        interval={4000}
        pause={false}
        className="h-100"
      >
        {heroImages.map((img, index) => (
          <Carousel.Item key={index} className="hero-slide-item">
            <img
              className="hero-slide-img"
              src={img}
              alt={`Slide ${index + 1}`}
            />
            <div className="hero-overlay"></div>
          </Carousel.Item>
        ))}
      </Carousel>

      <div className="hero-content-wrapper">
        <div className="glass-panel slide-up-animation">
          <span className="text-white fw-bold text-uppercase tracking-wider small mb-3 d-block">
            The Future of Finance
          </span>
          <h1 className="display-3 fw-bold mb-4 text-white">
            Fund, Invest & <br />
            <span className="text-warning">Grow Wealth</span>
          </h1>
          <p className="lead text-light mb-5 mx-auto" style={{ maxWidth: '700px' }}>
            Join the ultimate platform for Crowdfunding, Social Causes,
            Smart Investments, and High-Yield Savings. Secure your future today.
          </p>

          <div className="d-flex justify-content-center gap-3">
            <Button
              className="btn-primary-custom px-5 py-3 border-0"
              style={{ background: 'var(--primary-color)' }}
              onClick={() => setModalNotify(true)}
            >
              Get Started
            </Button>
            <Button
              className="bg-transparent border border-white text-white px-5 py-3 rounded-pill fw-bold hover-white"
              onClick={() => setModalNotify(true)}
              style={{ backdropFilter: 'blur(5px)' }}
            >
              Learn More
            </Button>
          </div>

          <div className="mt-5 d-flex align-items-center justify-content-center gap-3">
            <div className="d-flex">
              {[1, 2, 3].map(i => (
                <div
                  key={i}
                  className="rounded-circle border border-2 border-white bg-secondary"
                  style={{ width: '40px', height: '40px', marginLeft: i > 1 ? '-15px' : 0 }}
                />
              ))}
            </div>
            <div className="small text-white opacity-75">
              Trusted by <strong>10k+</strong> users
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Hero;
